module.exports = __webpack_public_path__ + "img/jinzita.fcdf8314.png";